<template>
  <button @click="onClick">
    <activity-unread-icon v-if="isActive" />
    <activity-icon v-else />
  </button>
</template>
<script>
import ActivityIcon from '@/assets/icons/activity.svg';
import ActivityUnreadIcon from '@/assets/icons/activity-unread.svg';

export default {
  name: 'ActivityButton',
  components: {
    ActivityIcon,
    ActivityUnreadIcon
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
};
</script>
<style scoped>
button svg {
  width: 48px;
  height: 48px;
}

@media (max-width: 1536px) {
  button svg {
    width: 40px;
    height: 40px;
  }
}
</style>
